// extracted by mini-css-extract-plugin
export default {"root":"QueryTypeSelect_root__-Vy6R","container":"QueryTypeSelect_container__ZKb4U"};